<template>
    <div id="page_pagenotfound" class="container">
        <div class="error">
            <div class="error-number">404</div>
            <div class="error-text">
                <h1>PAGE NOT FOUND</h1>
                <p>{{ currentPage }}</p>
                <p>Something went wrong. We couldn't find this page.</p>
                <router-link class="btn btn-primary" to="/"><fa-icon icon="home" class="me-2" />Home</router-link>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    #page_pagenotfound {
         text-align: center;
        .error-number {
            font-size: 200px;
        }
        h1 {
            font-size: 80px;
            margin: 30px 0 25px;
        }
        .error .error-text p {
            font-size: 30px;
            line-height: 45px;
            padding: 0 50px;
            margin: 0 0 25px;
        }
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";

export default defineComponent({
    name: "PageNotFound",
    extends: PageBase,
    data() {
        return {
            currentPage: globalThis.location.toString()
        };
    }
});

</script>
